var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15131_10759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79068 1.95814H3.91701C3.37533 1.95814 2.91196 2.28446 2.71617 2.75435L0.745226 7.35539C0.686489 7.5055 0.653858 7.66213 0.653858 7.83181V9.13707C0.653858 9.85497 1.24123 10.4423 1.95912 10.4423H6.07721L5.45721 13.4249L5.43764 13.6337C5.43764 13.9013 5.54858 14.1493 5.72479 14.3255L6.41658 15.0107L10.7174 10.7099C10.9524 10.475 11.0959 10.1486 11.0959 9.7897V3.2634C11.0959 2.54551 10.5086 1.95814 9.79068 1.95814ZM9.79068 9.7897L6.95826 12.6221L7.83279 9.13707H1.95912V7.83181L3.91701 3.2634H9.79068V9.7897ZM15.0117 9.7897H12.4012V1.95814H15.0117V9.7897Z",
    fill: "#DF6C20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15131_10759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6631,
    height: 15.6631,
    fill: "white",
    transform: "matrix(-1 0 0 -1 15.6641 15.6631)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.bef4e74eb5fcfac95ddf88562a119c97.svg";
export { ForwardRef as ReactComponent };